import { COMPANIES } from '../constants';
import { filterWeeksOnDestinationByCompany } from '../helpers/week';
// import { deNormalizeData } from '../helpers/yachts';

export const initialState = {
  destinations: {},
  cabins: {
    data: {},
    loaded: false,
  },
  weeks: {},
  crew: {
    boys: 4,
    girls: 4,
    skipper: 1,
    hostess: 1,
    total: 10,
    ratio: 56,
  },
  // yachts: {
  //   items: [],
  //   available: [],
  //   filtered: [],
  //   selectedTypes: [],
  //   selectedHulls: [],
  //   selectedAmenities: [],
  //   selectedPartners: [],
  //   selectedMarina: '',
  //   // currency: undefined,
  //   sortBy: {
  //     value: 1,
  //     label: 'Recommended',
  //   },
  //   lastUpdated: undefined,
  //   capacity: {
  //     min: CAPACITY.MIN,
  //     max: CAPACITY.MAX,
  //   },
  // },
};

const ynf = (state = initialState, action) => {
  switch (action.type) {
    case 'YNF_FETCH_DESTINATIONS': {
      const companyDestinations = action.destinations
        .map(d => ({ ...d, weeks: filterWeeksOnDestinationByCompany(d, COMPANIES.YNF) }))
        .filter(d => d.weeks.length);
      return {
        ...state,
        destinations: {
          ...state.destinations,
          items: companyDestinations,
          // selected: action.destinations && action.destinations.find(d => d.id === DESTINATION.GREECE),
        },
      };
    }
    // case 'YNF_FETCH_YACHTS': {
    //   const boatWeeks = deNormalizeData(action.data);
    //   return {
    //     ...state,
    //     yachts: {
    //       ...state.yachts,
    //       items: boatWeeks,
    //       lastUpdated: Date.now(),
    //     },
    //   };
    // }
    case 'YNF_SELECT_DESTINATION':
      return {
        ...state,
        destinations: {
          ...state.destinations,
          selected: state.destinations.items.find(d => d.id === action.id),
        },
        weeks: {
          ...state.weeks,
          items: action.weeks,
        },
      };
    case 'YNF_SELECT_WEEK':
      return {
        ...state,
        weeks: {
          ...state.weeks,
          items: state.weeks.items.map(item => (
            item.week === action.weekNumber && item.year === action.year ?
              { ...item, selected: !item.selected } :
              item
          )),
        },
      };
    case 'YNF_SELECT_CABIN_WEEK':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          week: action.week,
        },
      };
    case 'YNF_UNSELECT_ALL_WEEKS':
      return {
        ...state,
        weeks: {
          ...state.weeks,
          items: state.weeks && state.weeks.items && state.weeks.items.map(item => ({
            ...item,
            selected: false,
          })),
        },
      };
    case 'YNF_SET_CABIN_WEEKS':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          data: action.data,
          loaded: true,
        },
      };
    case 'YNF_FILTER_CABIN_WEEKS':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          weeks: action.weeks,
        },
      };
    case 'YNF_CHANGE_CABIN_TYPE':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          cabinType: action.cabinType,
        },
      };
    case 'YNF_CHANGE_SOLO_TYPE':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          soloType: action.soloType,
        },
      };
    case 'YNF_CLEAR_CABIN_AND_SOLO_TYPE':
      return {
        ...state,
        cabins: {
          ...state.cabins,
          cabinType: [],
          soloType: [],
        },
      };
    // case 'YNF_CHANGE_CREW': {
    //   const total = Object.keys(action.crew).reduce((acc, value) => acc + action.crew[value], 0);
    //   return {
    //     ...state,
    //     crew: {
    //       ...action.crew,
    //       total,
    //       ratio: calculateRatio({ ...action.crew, total }),
    //     },
    //   };
    // }
    default:
      return state;
  }
};

export default ynf;
